import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
import { CustomerCategory, CustomerCategoryOld } from './CustomerCategory';
import { CustomerNotificationPreferences } from './CustomerNotification';
import { Language } from './Language';
import { User } from './User';
import { Wholesaler } from './Wholesaler';
export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["Pending"] = "Pending";
    CustomerStatus["Accepted"] = "Accepted";
    CustomerStatus["Declined"] = "Declined";
    CustomerStatus["Blocked"] = "Blocked";
})(CustomerStatus || (CustomerStatus = {}));
export class CustomerSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.categories = [];
        this.language = Language.nl;
        this.businessName = "";
        this.VATNumber = "";
        this.contactName = "";
        this.contactPhone = "";
        this.city = "";
        this.postalCode = "";
        this.address = "";
        this.internalClientName = "";
        this.number = "";
        this.status = CustomerStatus.Pending;
        this.notificationsEnabled = true;
        this.isTester = false;
        this.notificationPreferences = null;
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(new EnumDecoder(CustomerCategoryOld)) }),
    field({ decoder: new ArrayDecoder(new EnumDecoder(CustomerCategory)), version: 20, upgrade: (o) => {
            return o.flatMap(c => {
                if (Object.values(CustomerCategory).includes(c)) {
                    return [c];
                }
                console.warn("Still found an old category: " + c);
                return [];
            });
        } })
], CustomerSettings.prototype, "categories", void 0);
__decorate([
    field({ decoder: new EnumDecoder(Language), version: 11 })
], CustomerSettings.prototype, "language", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CustomerSettings.prototype, "businessName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CustomerSettings.prototype, "VATNumber", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CustomerSettings.prototype, "contactName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CustomerSettings.prototype, "contactPhone", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, version: 14 })
], CustomerSettings.prototype, "city", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, version: 25 })
], CustomerSettings.prototype, "postalCode", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, version: 25 })
], CustomerSettings.prototype, "address", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, version: 25 })
], CustomerSettings.prototype, "internalClientName", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 7 })
], CustomerSettings.prototype, "number", void 0);
__decorate([
    field({ decoder: new EnumDecoder(CustomerStatus) })
], CustomerSettings.prototype, "status", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 16 })
], CustomerSettings.prototype, "notificationsEnabled", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 23 })
], CustomerSettings.prototype, "isTester", void 0);
__decorate([
    field({ decoder: CustomerNotificationPreferences, version: 27, optional: true, nullable: true })
], CustomerSettings.prototype, "notificationPreferences", void 0);
export var DeviceTokenType;
(function (DeviceTokenType) {
    DeviceTokenType["iOS"] = "iOS";
    DeviceTokenType["Android"] = "Android";
})(DeviceTokenType || (DeviceTokenType = {}));
export class DeviceToken extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.type = DeviceTokenType.iOS;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], DeviceToken.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(DeviceTokenType) })
], DeviceToken.prototype, "type", void 0);
export class CustomerServerSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.deviceTokens = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(DeviceToken), version: 9 })
], CustomerServerSettings.prototype, "deviceTokens", void 0);
/**
 * Customer data that is visible for the customer
 */
export class Customer extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = CustomerSettings.create({});
    }
}
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "id", void 0);
__decorate([
    field({ decoder: CustomerSettings })
], Customer.prototype, "settings", void 0);
__decorate([
    field({ decoder: Wholesaler })
], Customer.prototype, "wholesaler", void 0);
/**
 * Customer data that is visible for dashboard users
 */
export class CustomerPrivate extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = CustomerSettings.create({});
        this.createdAt = new Date();
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], CustomerPrivate.prototype, "id", void 0);
__decorate([
    field({ decoder: CustomerSettings })
], CustomerPrivate.prototype, "settings", void 0);
__decorate([
    field({ decoder: User, version: 8 })
], CustomerPrivate.prototype, "user", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 13 })
], CustomerPrivate.prototype, "wholesalerId", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 15 })
], CustomerPrivate.prototype, "createdAt", void 0);
/**
 * Customer data that is visible for the customer
 */
export class CreateCustomer extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = CustomerSettings.create({});
    }
    getId() {
        return IDCreateCustomer.create({
            settings: this.settings,
            wholesalerId: this.wholesaler.id
        });
    }
}
__decorate([
    field({ decoder: CustomerSettings })
], CreateCustomer.prototype, "settings", void 0);
__decorate([
    field({ decoder: Wholesaler })
], CreateCustomer.prototype, "wholesaler", void 0);
/**
 * Customer data that is visible for the customer
 */
export class IDCreateCustomer extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = CustomerSettings.create({});
    }
}
__decorate([
    field({ decoder: CustomerSettings })
], IDCreateCustomer.prototype, "settings", void 0);
__decorate([
    field({ decoder: StringDecoder })
], IDCreateCustomer.prototype, "wholesalerId", void 0);
//# sourceMappingURL=Customer.js.map